export default "__VITE_ASSET__Cjgq2UFE__"